import { CommonModule } from '@angular/common';
import { Component, computed, input, Input, Type } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { ObjectType } from '@galaxy/crm/static';
import { CrmObjectInterface } from '@vendasta/crm';

@Component({
  selector: 'crm-dynamic-profile-header-cards',
  imports: [CommonModule, MatExpansionModule],
  templateUrl: './dynamic-profile-header-cards.component.html',
})
export class DynamicProfileHeaderCardsComponent {
  @Input({ required: true }) component?: Type<any>;

  crmObject = input<CrmObjectInterface | undefined>(undefined);
  crmObjectType = input<ObjectType | undefined>(undefined);

  inputs = computed(() => {
    return {
      crmObject: this.crmObject(),
      crmObjectType: this.crmObjectType(),
    };
  });
}
